import HomePage from './components/HomePage'

// Sync route definition
export default {
  path: '/',
  component: HomePage
}
